module.exports = __webpack_public_path__ + "static/media/north_delta_centre_for_the_arts.4562037d.jpg";